import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import image29 from '../assets/image00029.jpeg';
import './About.css';

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const containerRef = useRef(null);
  const imageRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  // Refs des vagues supprimées

  useEffect(() => {
    const container = containerRef.current;
    const image = imageRef.current;
    const title = titleRef.current;
    const text = textRef.current;
    // Wave ref supprimée

    if (!container || !image || !title || !text) return;
    
    // ⚡ Performance detection
    // const perf = detectPerformanceCapabilities();

    // Timeline principale
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top 80%",
        end: "bottom 20%",
        toggleActions: "play none none reverse"
      }
    });

    // Animations des vagues supprimées - Section À propos plus épurée

    // Animation de l'image (gauche)
    gsap.set(image, { opacity: 0, x: -50, scale: 0.9 });
    
    tl.to(image, {
      opacity: 1,
      x: 0,
      scale: 1,
      duration: 0.8,
      ease: "power2.out"
    }, 0.2);

    gsap.set(title, {
      transformOrigin: "50% 50%",
      rotation: -20,
      scale: 0.9,
      opacity: 0
    });
    
    tl.to(title, {
      rotation: 8,
      scale: 1,
      opacity: 1,
      duration: 1,
      ease: "elastic.out(1, 0.5)"
    }, 0.4);

    // Plus de sous-titre à animer

    // Animation du texte par paragraphes
    const paragraphs = text.querySelectorAll('p');
    gsap.set(paragraphs, { opacity: 0, y: 30 });
    
    tl.to(paragraphs, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      stagger: 0.15,
      ease: "power2.out"
    }, 0.6);

    // Animation de parallax supprimée avec les vagues

    // Nettoyage simplifié
    return () => {
      ScrollTrigger.getAll().forEach(trigger => {
        if (trigger.trigger === container) {
          trigger.kill();
        }
      });
    };
  }, []);

  return (
    <section className="about-section" ref={containerRef}>
      {/* Vagues supprimées pour un design plus épuré */}

      <div className="about-container">
        {/* Image à gauche (comme dans la référence) */}
        <div className="about-image" ref={imageRef}>
          <div className="image-placeholder">
            <img 
              src={image29} 
              alt="Ambiance Pinky Cloud - Hamac rose cosy" 
              className="about-main-image"
            />
            {/* Emojis sur l'image supprimés pour un rendu plus propre */}
            <div className="image-overlay">
              <h3>L'ambiance Pinky Cloud</h3>
              <p>Un univers cosy et chaleureux pour vous détendre</p>
            </div>
          </div>
        </div>

        {/* Contenu à droite (comme dans la référence) */}
        <div className="about-content">
          {/* Titre À propos dans un cadre orange */}
          <div className="about-title a-propos" ref={titleRef}>
            À propos
          </div>

          {/* Texte descriptif */}
          <div className="about-text" ref={textRef}>
            <p>
              Bienvenue chez Pinky Cloud, votre nouvelle adresse gourmande au cœur du 11ᵉ arrondissement ! Ici, on célèbre le plaisir sucré sous toutes ses formes, des desserts réconfortants aux boissons fraîches et colorées.
            </p>
            <p>
              Pour ceux qui aiment l'originalité, nos bubble teas artisanaux (perles fruitées, sirops exotiques et bases de thé noir ou jasmin) sont un incontournable rafraîchissant.
            </p>
            <p>
              Mais ce n'est pas tout : découvrez aussi nos pancakes personnalisables à volonté, nos smoothies et milkshakes onctueux, sans oublier nos surprenants burgers et hot-dogs sucrés. Pourquoi choisir quand on peut tout déguster ? Chez Pinky Cloud, on mixe chaleur et fraîcheur, douceur et fantaisie, pour vous offrir un moment de pur bonheur, en solo ou entre amis.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;